import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";

export class AffiliationSchemaDataModel extends BaseSchemaDataModel {
}

export class AffiliationSchemaModel extends BaseSchemaModel {
  model: AffiliationSchemaDataModel;

  constructor(model: AffiliationSchemaDataModel) {
    super(SCHEMA_TYPE.organization, model.name, model.url);

    this.model = model;
  }

  get typeParams(): String {
    return this.type ? `"@type":"${this.type}"` : ``;
  }

  toString(): String {
    return `${this.typeParams}${this.nameParams}${this.urlParams}`;
  }
}
